import React from 'react'
import { ListItemText } from '@material-ui/core'

export default function MListItemText(props) {
    const { children, ...otherProps } = props;
    return (
        <ListItemText {...otherProps}>
            {children}
        </ListItemText>
    )
}
